import './SectionHeading.css'

const SectionHeading = () => {

  return (
    <div className="section-heading text-center">
        <h2 className="title-head-subscribe" data-aos="fade-up">Don’t Miss News And Updates!</h2>
    </div>
  );
}

export default SectionHeading;